/* eslint-disable @typescript-eslint/no-explicit-any */
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { NCMChanges } from "./ncm-changes";
import { NCMInfo } from "./ncm-info";

const TAX_TYPE_TRANSLATIONS: { [key: string]: string } = {
  CREATION: "Criação",
  UPDATE: "Atualização",
  DELETE: "Exclusão",
};

export function ModalNCMDetails({ requestData }: { requestData: any }) {
  const { ncm_values, tax_type_request, type, created_at, updated_at } =
    requestData;
  const changes = ncm_values?.changeHistory || ncm_values;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <NCMInfo label="Email" value={requestData.email} />
        <NCMInfo label="Responsável" value={requestData.responsible} />
      </div>

      <div className="grid grid-cols-2 gap-6">
        <NCMInfo
          label="Tipo de Solicitação"
          value={TAX_TYPE_TRANSLATIONS[tax_type_request] || tax_type_request}
        />
        <NCMInfo label="Tipo Fiscal" value={type} />
      </div>

      <div className="grid grid-cols-2 gap-6">
        <NCMInfo
          label="Criado em"
          value={format(new Date(created_at), "dd/MM/yyyy HH:mm:ss", {
            locale: ptBR,
          })}
        />
        <NCMInfo
          label="Atualizado em"
          value={format(new Date(updated_at), "dd/MM/yyyy HH:mm:ss", {
            locale: ptBR,
          })}
        />
      </div>
      {typeof ncm_values === "number" && (
        <NCMInfo label="Código NCM" value={String(ncm_values)} />
      )}

      {tax_type_request !== "CREATION" && <NCMChanges changes={changes} />}
    </div>
  );
}
